var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaWordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.047,
    viewBox: "0 0 18 18.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Word2_18PX",
    transform: "translate(0 0.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2135",
    "data-name": "Group 2135",
    transform: "translate(-288 -160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2134",
    "data-name": "Group 2134",
    transform: "translate(0 56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_748",
    "data-name": "Rectangle 748",
    width: 18,
    height: 18,
    transform: "translate(288 104)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file",
    transform: "translate(286.772 102.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M11.446,2H5.655A1.655,1.655,0,0,0,4,3.655V16.892a1.655,1.655,0,0,0,1.655,1.655h9.928a1.655,1.655,0,0,0,1.655-1.655v-9.1Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M13,2V7.791h5.791",
    transform: "translate(-1.554)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "W",
    transform: "translate(293 119)",
    fill: "#0d0d0d",
    fontSize: 9,
    fontFamily: "Arial-Black, Arial",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaWordIcon);
export default __webpack_public_path__ + "static/media/media-word-icon.4043ff6208ea39446cc690636e43ca4e.svg";
export { ForwardRef as ReactComponent };